import _classCallCheck from "/var/www/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component, createRef } from 'react';
import { createPortal } from 'react-dom';
import { Calendar } from '@fullcalendar/core';
import { CustomRenderingStore } from '@fullcalendar/core/internal';

var FullCalendar = /*#__PURE__*/function (_Component) {
  _inherits(FullCalendar, _Component);

  function FullCalendar() {
    var _this;

    _classCallCheck(this, FullCalendar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullCalendar).apply(this, arguments));
    _this.elRef = createRef();
    _this.needsCustomRenderingResize = false;
    _this.isInitialRender = true;
    _this.state = {
      customRenderingMap: new Map()
    };
    return _this;
  }

  _createClass(FullCalendar, [{
    key: "render",
    value: function render() {
      var portalNodes = [];

      var _iterator = _createForOfIteratorHelper(this.state.customRenderingMap.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var customRendering = _step.value;
          var generatorMeta = customRendering.generatorMeta;
          var vnode = typeof generatorMeta === 'function' ? generatorMeta(customRendering.renderProps) : generatorMeta;
          portalNodes.push(createPortal(vnode, customRendering.containerEl, customRendering.id));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return React.createElement("div", {
        ref: this.elRef
      }, portalNodes);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var customRenderingStore = new CustomRenderingStore();
      this.handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
      this.calendar = new Calendar(this.elRef.current, Object.assign(Object.assign({}, this.props), {
        handleCustomRendering: this.handleCustomRendering
      }));
      this.calendar.render();
      customRenderingStore.subscribe(function (customRenderingMap) {
        if (_this2.isInitialRender) {
          _this2.doCustomRendering(customRenderingMap);
        } else {
          _this2.requestCustomRendering(customRenderingMap);
        }
      });
    }
  }, {
    key: "requestCustomRendering",
    value: function requestCustomRendering(customRenderingMap) {
      var _this3 = this;

      this.cancelCustomRendering();
      this.customRenderingRequestId = requestAnimationFrame(function () {
        FullCalendar.act(function () {
          _this3.doCustomRendering(customRenderingMap);
        });
      });
    }
  }, {
    key: "doCustomRendering",
    value: function doCustomRendering(customRenderingMap) {
      this.needsCustomRenderingResize = true;
      this.setState({
        customRenderingMap: customRenderingMap
      });
    }
  }, {
    key: "cancelCustomRendering",
    value: function cancelCustomRendering() {
      if (this.customRenderingRequestId) {
        cancelAnimationFrame(this.customRenderingRequestId);
        this.customRenderingRequestId = undefined;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.isInitialRender = false;
      this.calendar.resetOptions(Object.assign(Object.assign({}, this.props), {
        handleCustomRendering: this.handleCustomRendering
      }));

      if (this.needsCustomRenderingResize) {
        this.needsCustomRenderingResize = false;
        this.calendar.updateSize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.calendar.destroy();
      this.cancelCustomRendering();
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.calendar;
    }
  }]);

  return FullCalendar;
}(Component);

export { FullCalendar as default };

FullCalendar.act = function (f) {
  f();
};